// Lib
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '@mui/material'
import { useDispatch } from 'react-redux'
import { Form, useFormikContext } from 'formik'
import _ from 'lodash'

// Images
import deleteSVG from 'images/commons/delete.svg'
import closeSVG from 'images/commons/close.svg'

// Include in project
import styles from './index.module.scss'
import { Button, TextField, SelectSingle } from 'component'
import { setOpenDialog } from 'states/slice/modalDialog'
import { ETransformationDataToServer } from 'utils/tranformData'
import { useHandleActionMasterData } from 'hooks'
import { ETagColor } from 'utils/generated'

interface Props {
  openModal: boolean
  closeModal: () => void
  createTags: any
  updateTags: any
  deleteTags: any
  refetchTagsList: any
  refetchTagsTrashList: any
}

const ModalOfTags: React.FC<Props> = (props: Props): JSX.Element => {
  const { values, errors, handleSubmit, setFieldValue } = useFormikContext<any>()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { handleUpdate, handleDelete } = useHandleActionMasterData({
    errors,
    values,
    createMasterData: props.createTags,
    updateMasterData: props.updateTags,
    typeUpdateMasterData: ETransformationDataToServer.UpdateTags,
    deleteMasterData: props.deleteTags,
    refetchMasterData: props.refetchTagsList,
    refetchMasterDataTrashList: props.refetchTagsTrashList,
    closeModal: props.closeModal,
    key: 'tagID',
  })

  return (
    <Modal open={props.openModal} onClose={props.closeModal}>
      <Form className={styles.containerModal}>
        <div className={styles.section}>
          <h3>Tags Details</h3>
          <img className={styles.closeIcon} src={closeSVG} alt="closeSVG" onClick={props.closeModal} />
        </div>
        <TextField name={`formInput.tagName`} type="text" label="Tags" require />
        <SelectSingle
          name={'formInput.typeTag'}
          label="Type"
          option={[
            {
              label: 'RETAILER',
              value: 'RETAILER',
            },
            {
              label: 'PRODUCT',
              value: 'PRODUCT',
            },
          ]}
          disabled={false}
          require
        />
        {/* <div> // TODO
          <p>Color</p>
          <div className={styles.headInputColor}>
            {dataInputColorMap.map((data, index) => {
              return (
                <div
                  key={index}
                  className={styles.boxInputColor}
                  style={values.formInput.tagColor === data.id ? { border: `2px solid ${data.value}` } : {}}
                  onClick={() => {
                    setFieldValue(`formInput.tagColor`, data.id)
                  }}
                >
                  <q
                    className={styles.colorLabel}
                    htmlFor={`formInput.tagColor`}
                    style={{ backgroundColor: `${data.value}` }}
                  ></q>
                </div>
              )
            })}
          </div>
        </div> */}
        <div className={styles.rowButton}>
          {values.formInput.tagID && (
            <div className={styles.button}>
              <Button
                typeButton="button"
                type={'outline'}
                disabled={false}
                name={t<string>('common.delete')}
                icon={deleteSVG}
                fullWidth
                functionOnClick={() =>
                  dispatch(
                    setOpenDialog({
                      title: t<string>('tagsManagement.deleteTitle'),
                      description: t<string>('tagsManagement.deleteDescription'),
                      status: 'danger',
                      functionOnSubmit: handleDelete,
                    }),
                  )
                }
              />
            </div>
          )}
          <div className={styles.button}>
            <Button
              typeButton="submit"
              type={'primary'}
              disabled={false}
              name={t<string>('common.save')}
              fullWidth
              functionOnClick={() => {
                handleSubmit()
                handleUpdate()
              }}
            />
          </div>
        </div>
      </Form>
    </Modal>
  )
}

export default ModalOfTags

const dataInputColorMap = [
  {
    id: 'white',
    value: '#FFFFFF',
  },
  {
    id: ETagColor.Red,
    value: '#FF635B',
  },
  {
    id: ETagColor.Orange,
    value: '#FFA93B',
  },
  {
    id: ETagColor.Yellow,
    value: '#FFD93A',
  },
  {
    id: ETagColor.Green,
    value: '#57DA67',
  },
  {
    id: ETagColor.Blue,
    value: '#3B93FF',
  },
  {
    id: ETagColor.Purple,
    value: '#C473F3',
  },
  {
    id: ETagColor.Gray,
    value: '#A3A3A7',
  },
]
